import Mutations from '../../odata/mutations';

export default { ...new Mutations('companySetting'), ...new Mutations('companySettings') };
